import React from 'react';
import { PropTypes } from 'prop-types';
import styles from './Card.css';

const Card = ({ children, title, titleCentered, onEdit, editLabel }) => (
  <div className={title ? styles.cardWithTitle : styles.card}>
    <p className={titleCentered ? styles.centeredTitle : styles.title}>
      {title}
      <button className={styles.editButton} onClick={onEdit}>
        {editLabel || 'edit'}
      </button>
    </p>
    {children}
  </div>
);

Card.displayName = 'Card';

Card.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.element,
  ]).isRequired,
  title: PropTypes.string,
  titleCentered: PropTypes.bool,
  onEdit: PropTypes.func,
  editLabel: PropTypes.string,
};

export default Card;



// WEBPACK FOOTER //
// ./src/components/Card.jsx